var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.755 4.62707C11.9863 4.74266 12.2414 4.80284 12.5 4.80284C12.7586 4.80284 13.0137 4.74266 13.245 4.62707L16.2942 3.10207C16.4213 3.03853 16.5626 3.00857 16.7046 3.01504C16.8466 3.02151 16.9845 3.06418 17.1054 3.13901C17.2262 3.21384 17.3259 3.31833 17.395 3.44255C17.4641 3.56677 17.5002 3.7066 17.5 3.84873V14.4854C17.4999 14.6401 17.4568 14.7918 17.3754 14.9233C17.294 15.0549 17.1776 15.1612 17.0392 15.2304L13.245 17.1279C13.0137 17.2435 12.7586 17.3037 12.5 17.3037C12.2414 17.3037 11.9863 17.2435 11.755 17.1279L8.245 15.3729C8.01367 15.2573 7.75861 15.1971 7.5 15.1971C7.24139 15.1971 6.98634 15.2573 6.755 15.3729L3.70584 16.8979C3.57863 16.9615 3.43727 16.9914 3.29522 16.9849C3.15316 16.9784 3.01513 16.9357 2.89427 16.8607C2.7734 16.7858 2.67372 16.6812 2.60471 16.5569C2.5357 16.4325 2.49965 16.2926 2.5 16.1504V5.51457C2.50009 5.35985 2.54324 5.20821 2.62463 5.07663C2.70602 4.94505 2.82244 4.83872 2.96084 4.76957L6.755 2.87207C6.98634 2.75647 7.24139 2.69629 7.5 2.69629C7.75861 2.69629 8.01367 2.75647 8.245 2.87207L11.755 4.62707Z",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.80371V17.3037",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.69629V15.1963",
    stroke: "#DBEAFE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateIcon);
export default __webpack_public_path__ + "static/media/state-icon.47e0627297703ce62a9d1c1a363fc250.svg";
export { ForwardRef as ReactComponent };